<template>
  <div class="flex justify-between border rounded-lg py-6 px-2 pr-3">
    <div>
      <!-- Pengerang -->
      <div class="flex mt-6">
        <i
          class="el-icon-location-outline text-blue-600 font-bold text-lg mr-1"
        ></i>
        <div class="text-blue-600">
          <span
            class="font-bold cursor-pointer"
            @mouseover="showMapPin('PDC')"
            @mouseleave="clearMapPin()">
            PENGERANG DATA CENTRE
          </span>
          <ol class="mt-1">
            <li>
              <span class="mr-2" style="font-size: 11px;">
                &bullet; AVG.TEMPERATURE: <strong>{{ data[0] }}</strong
                >&deg;C
              </span>
            </li>
            <li>
              <span class="mr-2" style="font-size: 11px;">
                &bullet; AVG HUMIDITY: <strong>{{ data[1] }}</strong
                >%rH
              </span>
            </li>
          </ol>
        </div>
      </div>
      <!-- THMO -->
      <div class="flex mt-10">
        <i
          class="el-icon-location-outline text-red-600 font-bold text-lg mr-1"
        ></i>
        <div class="text-blue-600">
          <span
            class="font-bold cursor-pointer" 
            @mouseover="showMapPin('THMO')"
            @mouseleave="clearMapPin()">
            THMO SERVER ROOM
          </span>
          <ol class="mt-1">
            <li>
              <span class="mr-2" style="font-size: 11px;">
                &bullet; AVG.TEMPERATURE: <strong>{{ data[2] }}</strong
                >&deg;C
              </span>
            </li>
            <li>
              <span class="mr-2" style="font-size: 11px;">
                &bullet; AVG HUMIDITY: <strong>{{ data[3] }}</strong
                >%rH
              </span>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <PetronasMap :mapPin="mapPin" />
    <!-- <img
      src="@/assets/images/petronas-gmap.png"
      class="rounded"
      style="width: 400px;"
    /> -->
  </div>
</template>

<script>
import PetronasMap from '@/components/PetronasMap.vue'

export default {
  components: {
    PetronasMap
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      mapPin: ''
    }
  },
  methods: {
    showMapPin(location) {
      this.mapPin = location
    },
    clearMapPin() {
      this.mapPin = ''
    }
  }
}
</script>
